import React, { useState } from "react";
import { PackageResponse } from "../../app/models/responseModels/packageResponse";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

interface PackageDetailsProps {
  packageRowData: PackageResponse;
}

const PackageDetails = ({ packageRowData }: PackageDetailsProps) => {
  // ***** States *****
  const [openPackageDetail, setOpenPackageDetail] = useState(true);
  const [openCustomerDetail, setOpenCustomerDetail] = useState(false);
  const [openPackageDimentions, setOpenPackageDimentions] = useState(false);

  return (
    <>
      {/* Package Detail */}
      <Accordion elevation={5} expanded={openPackageDetail}>
        <AccordionSummary
          onClick={() => setOpenPackageDetail(!openPackageDetail)}
          expandIcon={
            <>
              <IconButton
                onClick={() => setOpenPackageDetail(!openPackageDetail)}
                sx={{ color: "white" }}
              >
                <ExpandMore sx={{ color: "white" }} />
              </IconButton>
            </>
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            minHeight: "36px",
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
            "& .MuiAccordionSummary-content.Mui-expanded": {
              margin: 0,
            },

            "&.Mui-expanded": {
              minHeight: "36px",
            },
            backgroundColor: "primary.main",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              color: "white",
            }}
          >
            <Typography>Package Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ maxHeight: 440, overflowY: "scroll" }}>
          {/* sx={{ height: 220, overflowY: "scroll" }} */}
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Grid container rowSpacing={2} columnSpacing={2}>
              <Grid item xs={12} sm={5} md={5} lg={5}>
                <TextField
                  margin="normal"
                  id="deleted1"
                  label="Deleted"
                  name="deleted1"
                  size="small"
                  fullWidth
                  value={packageRowData.shipmentClientName}
                />
              </Grid>
              <Grid item xs={12} sm={5} md={5} lg={5}>
                <TextField
                  margin="normal"
                  id="deleted2"
                  label="Deleted"
                  name="deleted2"
                  size="small"
                  fullWidth
                  value={packageRowData.fdpCompanyName}
                />
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
      <br />
      {/* Customer Detail */}
      <Accordion elevation={5} expanded={openCustomerDetail}>
        <AccordionSummary
          onClick={() => setOpenCustomerDetail(!openCustomerDetail)}
          expandIcon={
            <>
              <IconButton
                onClick={() => setOpenCustomerDetail(!openCustomerDetail)}
                sx={{ color: "white" }}
              >
                <ExpandMore sx={{ color: "white" }} />
              </IconButton>
            </>
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            minHeight: "36px",
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
            "& .MuiAccordionSummary-content.Mui-expanded": {
              margin: 0,
            },

            "&.Mui-expanded": {
              minHeight: "36px",
            },
            backgroundColor: "primary.main",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              color: "white",
            }}
          >
            <Typography>Customer Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ maxHeight: 440, overflowY: "scroll" }}>
          {/* sx={{ height: 220, overflowY: "scroll" }} */}
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Grid container rowSpacing={2} columnSpacing={2}>
              <Grid item xs={12} sm={5} md={5} lg={5}>
                <TextField
                  margin="normal"
                  id="deleted4"
                  label="Deleted"
                  name="deleted4"
                  size="small"
                  fullWidth
                  value={packageRowData.shipmentRecipientName}
                />
              </Grid>
              <Grid item xs={12} sm={5} md={5} lg={5}>
                <TextField
                  margin="normal"
                  id="deleted3"
                  label="Deleted"
                  name="deleted3"
                  size="small"
                  fullWidth
                  value={packageRowData.shipmentRecipientAddressLine1}
                />
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
      <br />
      {/* Package Dimentions */}
      <Accordion elevation={5} expanded={openPackageDimentions}>
        <AccordionSummary
          onClick={() => setOpenPackageDimentions(!openPackageDimentions)}
          expandIcon={
            <>
              <IconButton
                onClick={() => setOpenPackageDimentions(!openPackageDimentions)}
                sx={{ color: "white" }}
              >
                <ExpandMore sx={{ color: "white" }} />
              </IconButton>
            </>
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            minHeight: "36px",
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
            "& .MuiAccordionSummary-content.Mui-expanded": {
              margin: 0,
            },

            "&.Mui-expanded": {
              minHeight: "36px",
            },
            backgroundColor: "primary.main",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              color: "white",
            }}
          >
            <Typography>Package Dimentions</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ maxHeight: 440, overflowY: "scroll" }}>
          {/* sx={{ height: 220, overflowY: "scroll" }} */}
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Grid container rowSpacing={2} columnSpacing={2}>
              <Grid item xs={12} sm={5} md={5} lg={5}>
                <TextField
                  margin="normal"
                  id="deleted5"
                  label="Deleted"
                  name="deleted5"
                  size="small"
                  fullWidth
                  value={packageRowData.packageWeight}
                />
              </Grid>
              <Grid item xs={12} sm={5} md={5} lg={5}>
                <TextField
                  margin="normal"
                  id="deleted6"
                  label="Deleted"
                  name="deleted6"
                  size="small"
                  fullWidth
                  value={
                    packageRowData.packageWidth
                      ? packageRowData.packageWidth
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default PackageDetails;
